import UINotificationItem from './Component';

export default UINotificationItem;